import { Text } from '@spotify-internal/encore-web';
import {
  StatusError,
  StatusOK,
  StatusPending,
  StatusWarning,
} from '@spotify/confidence-core-react';
import {
  MetricsTableErrorFragment,
  MetricsV1TableState,
} from '@spotify/confidence-graphql';

import styles from './TableState.module.css';

export const tableStateLabel = (status: MetricsV1TableState) => {
  switch (status) {
    case MetricsV1TableState.TableStateActive:
      return 'Active';
    case MetricsV1TableState.TableStateFailed:
      return 'Failed';
    case MetricsV1TableState.TableStateCreating:
      return 'Creating';
    case MetricsV1TableState.TableStateUpdating:
      return 'Updating';
    default:
      return 'Unknown';
  }
};

export const formatTableError = (
  error: Maybe<MetricsTableErrorFragment> | undefined,
): string | undefined => {
  if (error === undefined || error === null) {
    return undefined;
  }

  if (
    (error.message === null || error.message === '') &&
    error.details.length <= 0
  ) {
    return 'Unknown error occurred';
  }

  if (error.message !== null && error.details.length <= 0) {
    return error.message;
  }

  return `${error.message}:\n${error.details.join('\n')}`;
};

export function tableStateIcon(status: MetricsV1TableState) {
  switch (status) {
    case MetricsV1TableState.TableStateActive:
      return StatusOK;
    case MetricsV1TableState.TableStateFailed:
      return StatusError;
    case MetricsV1TableState.TableStateCreating:
      return StatusPending;
    case MetricsV1TableState.TableStateUpdating:
      return StatusPending;
    default:
      return StatusWarning;
  }
}

export const TableState = ({
  status,
  error,
}: {
  status: MetricsV1TableState;
  error: Maybe<MetricsTableErrorFragment> | undefined;
}) => {
  const Status = tableStateIcon(status);
  return (
    <div className={styles.root} title={formatTableError(error)}>
      <Status>
        <Text variant="bodySmall" as="span" className={styles.label}>
          {tableStateLabel(status)}
        </Text>
      </Status>
    </div>
  );
};
